import T from 'i18n-react'
import { createSelector } from 'reselect'
import curry from 'lodash/curry'
import * as R from 'ramda'
import {
  createSelectorWithPath,
  labelSelectorFunc,
} from 'helpers/ComponentSelectorUtil'
import {
  entitySelector
} from 'containers/Entity/selectors'

const valuesStateSelector = (state) => {
  return (
    state.values
  )

} 
const vendorStateSelector = (state) => {
  return(
    state.vendors
  )
}
const resolutionStateSelector = state => state.resolutions
const sizeStateSelector = state => state.sizes
const refreshRateStateSelector = state => state.refreshRates

const refreshRateSelectorHoc = (refreshRateStateSelector) => (
  createSelector(
    entitySelector,
    refreshRateStateSelector,
    (entities, refs) => refs.map(({id, type}) => entities[type][id])
  )
)

const refreshRateSourceSelectorHoc = (refreshRateSelector) => (
  createSelector(
    refreshRateSelector,
    values => values.map(({value, panelRefreshRateId}) => ({
      value: panelRefreshRateId,
      label: value
    }))
  )
)

const sizeSelectorHoc = (sizeStateSelector) => (
  createSelector(
    entitySelector,
    sizeStateSelector,
    (entities, refs) => refs.map(({id, type}) => entities[type][id])
  )
)

const sizeSourceSelectorHoc = (sizeSelector) => (
  createSelector(
    sizeSelector,
    values => values.map(({value, panelSizeId}) => ({
      value: panelSizeId,
      label: value
    }))
  )
)

const resolutionSelectorHoc = (resolutionStateSelector) => (
  createSelector(
    entitySelector,
    resolutionStateSelector,
    (entities, refs) => refs.map(({id, type}) => entities[type][id])
  )
)

const resolutionSourceSelectorHoc = (resolutionSelector) => (
  createSelector(
    resolutionSelector,
    (values) => values.map(({width, height, panelResolutionId}) => {
      const resolution = `${width} x ${height}`
      return { value: panelResolutionId, label: resolution }
    })
  )
)

const vendorSelectorHoc = (vendorStateSelector) => (
  createSelector(
    entitySelector,
    vendorStateSelector,
    (entities, refs) => refs.map(({id, type}) => entities[type][id])
  )
)

const vendorSourceSelectorHoc = (vendorSelector) => (
  createSelector(
    vendorSelector,
    values => values.map(({ panelVendorId, value }) => ({
      value: panelVendorId,
      label: value
    }))
  )
)

const sortedSelectorHoc = (selector) => (
  createSelector(
    selector,
    values => R.sortBy(R.compose(R.prop('label')))(values)
  )
)

export default (path) => {
  const withPath = createSelectorWithPath(path)
  const labelSelector = withPath(labelSelectorFunc)
  const valuesSelector = withPath(valuesStateSelector)
  const vendorSelector = withPath(vendorStateSelector)
  const resolutionSelector = withPath(resolutionStateSelector)
  const sizeSelector = withPath(sizeStateSelector)
  const refreshRateSelector = withPath(refreshRateStateSelector)

  const vendorRefSelector = vendorSelectorHoc(vendorSelector)
  const vendorSourceSelector = sortedSelectorHoc(vendorSourceSelectorHoc(vendorRefSelector))
  const sizeRefSelector = sizeSelectorHoc(sizeSelector)
  const sizeSourceSelector = sortedSelectorHoc(sizeSourceSelectorHoc(sizeRefSelector))
  const resolutionRefSelector = resolutionSelectorHoc(resolutionSelector)
  const resolutionSourceSelector = sortedSelectorHoc(resolutionSourceSelectorHoc(resolutionRefSelector))
  const refreshRateRefSelector = refreshRateSelectorHoc(refreshRateSelector)
  const refreshRateSourceSelector = sortedSelectorHoc(refreshRateSourceSelectorHoc(refreshRateRefSelector))

  return {
    labelSelector,
    valuesSelector,
    vendorSourceSelector,
    sizeSourceSelector,
    resolutionSourceSelector,
    vendorRefSelector,
    sizeRefSelector,
    resolutionRefSelector,
    refreshRateRefSelector,
    refreshRateSourceSelector,
  }
}
